import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

import { calculatePeriodDates, formatShortDateRange } from '../../../utils/dateUtils';

import PhoneMobileEquation from './PhoneMobileEquation';



const PERIODS = [

  { key: 'current-week', label: 'Week' },

  { key: 'current-fortnight', label: 'Fortnight' },

  { key: 'two-weeks', label: '2 wk' },

  { key: 'three-weeks', label: '3 wk' },

  { key: 'four-weeks', label: '4 wk' },

];



const PhoneMobileTracking = ({

  state,

  trackingPeriod,

  setTrackingPeriod,

  setShowUpdateBalance,

  graphElement,

}) => {

  const [graphOpen, setGraphOpen] = useState(false);

  const periodInfo = calculatePeriodDates(trackingPeriod, state.fortnightDates);



  return (

    <div className="phone-bills-tracking">

      <div className="phone-bills-period-scroll">

        {PERIODS.map((p) => (

          <button

            key={p.key}

            type="button"

            className={`phone-bills-period-pill ${

              trackingPeriod === p.key ? 'phone-bills-period-pill--active' : ''

            }`}

            onClick={() => setTrackingPeriod(p.key)}

          >

            {p.label}

          </button>

        ))}

      </div>



      <p className="phone-bills-period-label">

        {periodInfo.label} ({formatShortDateRange(periodInfo.start, periodInfo.end)})

      </p>



      <PhoneMobileEquation

        trackingPeriod={trackingPeriod}

        state={state}

        setShowUpdateBalance={setShowUpdateBalance}

      />



      {graphElement && (

        <>

          <button

            type="button"

            className="phone-bills-graph-toggle"

            onClick={() => setGraphOpen((o) => !o)}

            aria-expanded={graphOpen}

          >

            <span>Cash flow</span>

            <FontAwesomeIcon icon={graphOpen ? faChevronUp : faChevronDown} />

          </button>

          {graphOpen && <div className="phone-bills-graph-panel">{graphElement}</div>}

        </>

      )}

    </div>

  );

};



export default PhoneMobileTracking;

